import config from "../../config/config.json";
import { headers } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody
} from "../../APIHelpers/Responses";

export const subCategoryServices = {
  addNewDiscoverySubCategory,
  updatedDiscoverySubCategory,
  softDeleteRestoreDiscoverySubCategory,
  deleteDiscoverySubCategory,
  getDiscoverySubCategoryList,
};

// Add New Sub Category
async function addNewDiscoverySubCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewDiscoverySubCategory`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Sub Category
async function updatedDiscoverySubCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updatedDiscoverySubCategory`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  if(!userData?.bookmarkType){
    handleResponse(data)
  }
  return data;
}

// Soft Delete & Restore Sub Category
async function softDeleteRestoreDiscoverySubCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreDiscoverySubCategory`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  if(!userData?.bookmarkType){
    handleResponse(data)
  }
  return data;
}

// Delete Sub Category
async function deleteDiscoverySubCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteDiscoverySubCategory`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get All Sub Category
async function getDiscoverySubCategoryList(categoryId, status, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getDiscoverySubCategoryList/${categoryId}/${status}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getDiscoverySubCategoryList/${categoryId}/${status}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}